import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface EmFolderIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const EmFolderIcon = ({ className, ...props }: EmFolderIconProps) => (
  <svg
    className={cn(className)}
    fill="none"
    height="22"
    viewBox="0 0 22 22"
    width="22"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.1664 1.65859V1.26328C15.1664 0.945312 15.4242 0.6875 15.7421 0.6875H19.63C19.9479 0.6875 20.2057 0.945312 20.2057 1.26328V2.68297C20.412 2.68297 20.5787 2.84969 20.5787 3.05594V15.8297H1.4198V3.23297C1.4198 2.92875 1.66558 2.68297 1.9698 2.68297H14.1403C14.7075 2.68297 15.1664 2.22406 15.1664 1.65859Z"
      fill="#F3AB47"
    />
    <path
      d="M1.41992 5.91593V5.15453C1.41992 4.87609 1.64508 4.64922 1.92523 4.64922H20.0752C20.3537 4.64922 20.5805 4.87437 20.5805 5.15453V5.91593H1.41992Z"
      fill="#DE7340"
    />
    <path
      d="M13.5199 4.25907V3.86376C13.5199 3.54579 13.2621 3.28798 12.9441 3.28798H9.05633C8.73836 3.28798 8.48055 3.54579 8.48055 3.86376V4.25907C8.48055 4.82454 8.02164 5.28345 7.45617 5.28345H1.96992C1.6657 5.28345 1.41992 5.52923 1.41992 5.83345V18.8856H20.5788V5.83345C20.5788 5.52923 20.333 5.28345 20.0288 5.28345H14.5443C13.9788 5.28345 13.5199 4.82454 13.5199 4.25907Z"
      fill="#FFCA28"
    />
    <path
      d="M1.41992 8.53532V7.75501C1.41992 7.47657 1.64508 7.24969 1.92523 7.24969H20.0752C20.3537 7.24969 20.5805 7.47485 20.5805 7.75501V8.51641L1.41992 8.53532Z"
      fill="#F3AB47"
    />
    <path
      d="M6.83397 6.85781V6.4625C6.83397 6.14453 6.57616 5.88672 6.25819 5.88672H2.37038C2.05241 5.88672 1.7946 6.14453 1.7946 6.4625V7.88219C1.58835 7.88219 1.42163 8.04891 1.42163 8.25516V20.8244C1.42163 21.0925 1.63991 21.3108 1.90804 21.3108H20.0941C20.3623 21.3108 20.5805 21.0925 20.5805 20.8244V8.43219C20.5805 8.12797 20.3348 7.88219 20.0305 7.88219H7.85835C7.29288 7.88219 6.83397 7.42328 6.83397 6.85781Z"
      fill="#FFE36C"
    />
    <path
      d="M6.83393 6.85781V6.4625C6.83393 6.14453 6.57612 5.88672 6.25815 5.88672H2.37034C2.05237 5.88672 1.79456 6.14453 1.79456 6.4625V7.88219H7.86002C7.29284 7.88219 6.83393 7.42328 6.83393 6.85781Z"
      fill="#F44336"
    />
    <path
      d="M13.5198 4.25907V3.86376C13.5198 3.54579 13.262 3.28798 12.944 3.28798H9.05621C8.73824 3.28798 8.48043 3.54579 8.48043 3.86376V4.25907C8.48043 4.82454 8.02152 5.28345 7.45605 5.28345H14.5459C13.9787 5.28345 13.5198 4.82454 13.5198 4.25907Z"
      fill="#0288D1"
    />
    <path
      d="M20.2059 2.59016V1.26328C20.2059 0.945312 19.9481 0.6875 19.6301 0.6875H15.7423C15.4243 0.6875 15.1665 0.945312 15.1665 1.26328V1.65859C15.1665 2.07281 14.919 2.43031 14.5649 2.59016H20.2059Z"
      fill="#7CB342"
    />
  </svg>
);

export default EmFolderIcon;
